import { useBreakpoints } from '../../support/hooks/useBreakpoints.tsx';
import { Card } from './Card.tsx';

export const WrapWithCardOnLargerScreen: React.FC<{children: React.ReactNode}> = ({ children }) => {
    const { isLargerScreen } = useBreakpoints();

    if (isLargerScreen) {
        return <Card padded>{children}</Card>;
    } else {
        return <div>{children}</div>;
    }
};
